// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import MasterService from '@services/masters'

export const getBank = createAsyncThunk('bank/getBank', async (params, { rejectWithValue }) => {
  try {
    const response = await MasterService.getAllBank(params)
    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getBankById = createAsyncThunk('bank/getBankById', async (id) => {
  const response = await MasterService.getBankById(id)
  return response
})

export const addBank = createAsyncThunk('bank/addBank', async (bank, { rejectWithValue }) => {
  try {
    const response = await MasterService.addBank(bank)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateBank = createAsyncThunk('bank/updateBank', async (bank, { rejectWithValue }) => {
  try {
    const response = await MasterService.updateBank(bank)
    return response
  } catch (err) {
    rejectWithValue(err.response.data)
  }
})

export const deleteBank = createAsyncThunk('bank/deleteBank', async (id, { dispatch, getState }) => {
  await MasterService.deleteBank(id)
  await dispatch(getBank(getState()?.banks.params))
  return id
})

export const bankSlice = createSlice({
  name: 'bank',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    individualBank: null,
    loading: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBank.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getBankById.fulfilled, (state, action) => {
        state.individualBank = action.payload
        state.loading = false
      })
      .addCase(getBankById.pending, (state, action) => {
        state.individualBank = action.payload
        state.loading = true
      })
      .addCase(getBankById.rejected, (state, action) => {
        state.individualBank = action.payload
        state.loading = false
      })
  }
})

export default bankSlice.reducer
